import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { getI18nText } from 'pricing-pages-lib/utils/languageUtils';
import { getInAppPaymentsUrl } from 'pricing-pages-lib/utils/urls';
import { COMMERCE } from 'self-service-api/constants/EnrolledProductLines';
import { TRACKING_SOURCES } from '../../constants/tracking/TrackingSources';
import { useAppSelector } from '../../reducers';
import { isAppAuthSelector } from '../../selectors/AuthSelectors';
import { trackClickedLink } from '../../utils/tracking/trackingEventUtils';
import SignupButton from '../common/SignupButton';
import { jsx as _jsx } from "react/jsx-runtime";
const BringCommerceCTAs = () => {
  const isAppAuth = useAppSelector(isAppAuthSelector);
  const goToPaymentsUrl = getInAppPaymentsUrl();
  const handleGoToPayments = () => {
    trackClickedLink({
      name: 'go-to-payments-link',
      value: getI18nText('pricingPage.pages.commerce.goToPayments', {
        locale: 'en-us'
      }),
      type: 'external',
      url: goToPaymentsUrl
    });
  };

  // Sign-up on public page
  if (!isAppAuth) {
    return /*#__PURE__*/_jsx(SignupButton, {
      sourceId: "pricing-pages-commerce-hub-page",
      use: 'primary',
      productLine: COMMERCE,
      trackingSource: TRACKING_SOURCES.PRODUCT_PAGE,
      block: true
    });
  }

  // Go to payments zero state in-app
  return /*#__PURE__*/_jsx(Button, {
    use: 'primary',
    href: goToPaymentsUrl,
    onClick: handleGoToPayments,
    "data-test-id": "commerce-go-to-payments-zero-state",
    block: true,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "pricingPage.pages.commerce.goToPayments"
    })
  });
};
export default BringCommerceCTAs;